import './Reports.sass';

import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CSVLink } from 'react-csv';

import Spinner from '../../../commonComponents/Spinner/Spinner';
import AllCSVReport from './AllCSVReport/AllCSVReport';
import AssignedToWritersReport from './AssignedToWritersReport/AssignedToWritersReport';
import AudioAbbreviationsReport from './AudioAbbreviationsReport/AudioAbbreviationsReport';
import AudioReport from './AudioReport/AudioReport';
import BooksMissingAnswersReport from './BooksMissingAnswersReport/BooksMissingAnswersReport';
import FavoriteQuestionsReport from './FavoriteQuestionsReport/FavoriteQuestionsReport';
import ActiveSubscriptionsContainer from './GetActiveSubscriptions/getActiveSubscriptionsContainer';
import IntercomActiveUsersReport from './IntercomActiveUsersReport/IntercomActiveUsersReport';
import MasterUserReportContainer from './masterUserReport/MasterUserReportContainer';
import NumberOfQuestionsEnabledPerRatingExamContainer from './numberOfQuestionsEnabledPerRatingExam/NumberOfQuestionsEnabledPerRatingExamContainer';
import RateQuestionsReport from './RateQuestionsReport/RateQuestionsReport';
import ReferredLeadsReport from './ReferredLeadsReport/ReferredLeadsReport';
import SelfPromotionReport from './SelfPromotionReport/SelfPromotionReport';
import SubscriptionsTypesReport from './SubscriptionsTypesReport/SubscriptionsTypesReport';
import UsageStatisticsReport from './UsageStatisticsReport/UsageStatisticsReport';
// import UsersReport from './UsersReport/UsersReport';
import UserSubmittedQuestionsReport from './UserSubmittedQuestionsReport/UserSubmittedQuestionsReport';

const REPORTS = [
  {
    id: 0,
    name: 'Questions with manual order',
    url: 'loadManualOrderChapterQuestionsReport',
    filename: 'Manual-Order-Report',
  },
  {
    id: 1,
    name: 'Questions with TRUE or FALSE answer',
    url: 'loadBooleanAnswerQuestionsReport',
    filename: 'Boolean-Answers-Report',
  },
  {
    id: 2,
    name: '# of questions enabled per rating exam',
    url: 'loadNumberOfQuestionPerRatingExamReport',
    filename: 'Question-Number-Rating-Exam-Report',
  },
  {
    id: 3,
    name: 'All CSV Bibliography Data',
    url: 'allCSVBibliographyData',
    filename: 'Bibliography-Data-Report',
  },
  // @deprecated Not used by the client
  /* {
    id: 4,
    name: 'Users',
    url: 'users',
    filename: 'Users-Report',
  }, */
  {
    id: 5,
    name: 'Active Subscriptions',
    url: 'active-subscriptions',
    filename: 'Active-Subscriptions-Report',
  },
  {
    id: 6,
    name: 'Subscriptions Types Report',
    url: 'subscriptionsTypesReport',
    filename: 'Subscriptions-Types-Report',
  },
  {
    id: 7,
    name: 'Completion Status Report',
    url: 'getCompletionStatus',
    filename: 'Completion-Status-Report',
  },
  {
    id: 8,
    name: 'Master User Report',
    url: 'master-user-report',
    filename: 'Master-User-Report',
  },
  {
    id: 10,
    name: 'Pub Hunt Selections',
    url: 'pubHuntSelectionsReport',
    filename: 'pub-hunt-selections',
  },
  {
    id: 11,
    name: 'Favorite Questions Report',
    url: 'favoriteQuestionsReport',
    filename: 'Favorite-Questions-Report',
  },
  {
    id: 12,
    name: 'Admin User List',
    url: 'userListReport',
    filename: 'user-list-report',
  },
  {
    id: 13,
    name: 'Coupons report',
    url: 'couponsReport',
    filename: 'coupons-report',
  },
  {
    id: 14,
    name: 'User Submitted Questions Report',
    url: 'userSubmittedQuestionsReport',
    filename: 'user-submitted-questions-report',
  },
  {
    id: 15,
    name: 'Intercom Active Users Report',
    url: 'intercomActiveUsersReport',
    filename: 'intercom-active-users-report',
  },
  {
    id: 17,
    name: 'Rate Questions Report',
    url: 'rateQuestionsReport',
    filename: 'Rate-Questions-Report',
  },
  {
    id: 18,
    name: 'Usage Statistics Report',
    url: 'usageStatisticsReport',
    filename: 'Usage-Statistics-Report',
  },
  {
    id: 19,
    name: 'Audio Report',
    url: 'audioReport',
    filename: 'Audio-report',
  },
  {
    id: 20,
    name: 'Audio Abbreviations Report',
    url: 'audioAbbreviationsReport',
    filename: 'Audio-Abbreviations-Report',
  },
  {
    id: 21,
    name: 'Books Missing Answers Report',
    url: 'booksMissingAnswersReport',
    filename: 'Books-Missing-Answers-Report',
  },
  {
    id: 23,
    name: 'Referred Leads Report',
    url: 'referredLeadsReport',
    filename: 'Referred-Leads-Report',
  },
  {
    id: 24,
    name: 'Assigned to Writers',
    url: 'assignedToWriters',
    filename: 'Assigned-To-Writers',
  },
  {
    id: 25,
    name: 'Self Promotion Status',
    url: 'selfPromotionStatus',
    filename: 'Self-Promotion-Status-Report',
  },
];

export default class Reports extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedReport: REPORTS[0],
      filename: 'report.csv',
    };
  }

  componentDidMount() {
    if (this.props.rates.length === 0) {
      this.props.loadRates();
    }
  }

  componentDidUpdate() {
    if (this.props.report) {
      document.getElementById('report-download').click();
      this.props.onClearReport();
      this.setState({ filename: 'report.csv' });
    }
  }

  handleDownloadReport = () => {
    this.props.downloadReport(this.state.selectedReport.url);
    const selectedReport = REPORTS.find(
      (report) => report.id === this.state.selectedReport.id,
    );
    const name = selectedReport ? selectedReport.filename : 'Report';
    this.setState({
      filename: `${name}-${moment().format('MMM')}${moment().format(
        'DD',
      )}-${moment().format('YYYY')}.csv`,
    });
  };

  renderReportComponent = () => {
    const { selectedReport } = this.state;
    switch (selectedReport.id) {
      case 2:
        return <NumberOfQuestionsEnabledPerRatingExamContainer />;
      case 3:
        return (
          <AllCSVReport
            rates={this.props.rates}
            ratesIsLoading={this.props.ratesIsLoading}
            loadRates={this.props.loadRates}
            generateReportForSelectedRates={
              this.props.getBibliographyReportForGivenRates
            }
            bibliographyReport={this.props.bibliographyReport}
            bibliographyReportIsLoading={this.props.bibliographyReportIsLoading}
            bibliographyReportError={this.props.bibliographyReportError}
          />
        );
      // @deprecated Not used by the client
      /* case 4:
        return (
          <UsersReport
            graph={this.props.graph}
            setGraph={this.props.setGraph}
            rates={this.props.rates}
            isLoading={this.props.usersReportIsLoading}
            getUsersCount={this.props.getUsersCount}
            usersCount={this.props.usersCount}
          />
        ); */
      case 5:
        return <ActiveSubscriptionsContainer />;
      case 6:
        return (
          <SubscriptionsTypesReport
            generateSubscriptionTypesReport={
              this.props.generateSubscriptionTypesReport
            }
            getSubscriptionTypesReports={this.props.getSubscriptionTypesReports}
            subscriptionTypesReports={this.props.subscriptionTypesReports}
            subscriptionTypesReportsIsLoading={
              this.props.subscriptionTypesReportsIsLoading
            }
          />
        );
      case 8:
        return <MasterUserReportContainer />;
      case 11:
        return (
          <FavoriteQuestionsReport
            rates={this.props.rates}
            ratesIsLoading={this.props.ratesIsLoading}
            loadRates={this.props.loadRates}
            generateFavoriteQuestionsReport={
              this.props.generateFavoriteQuestionsReport
            }
            getLastFavoriteQuestionsReports={
              this.props.getLastFavoriteQuestionsReports
            }
            lastFavoriteQuestionsReports={
              this.props.lastFavoriteQuestionsReports
            }
            loadingFavoriteQuestionsReport={
              this.props.loadingFavoriteQuestionsReport
            }
          />
        );
      case 14:
        return (
          <UserSubmittedQuestionsReport
            rates={this.props.rates}
            isLoadingRates={this.props.ratesIsLoading}
            loadRates={this.props.loadRates}
            getUserSubmittedQuestionsReportForGivenRates={
              this.props.getUserSubmittedQuestionsReportForGivenRates
            }
            userSubmittedQuestionsReport={
              this.props.userSubmittedQuestionsReport
            }
            isUserSubmittedQuestionsReportLoading={
              this.props.isUserSubmittedQuestionsReportLoading
            }
            setUserSubmittedQuestionsReport={
              this.props.setUserSubmittedQuestionsReport
            }
            /* handleDownloadReport={this.handleDownloadReport} */
          />
        );
      case 15:
        return (
          <div className="report-centered">
            <IntercomActiveUsersReport
              getLatestIntercomActiveUsersReport={
                this.props.getLatestIntercomActiveUsersReport
              }
              generateIntercomActiveUsersReport={
                this.props.generateIntercomActiveUsersReport
              }
              intercomActiveUsersReport={this.props.intercomActiveUsersReport}
            />
          </div>
        );
      case 16:
        return <TopicsAndExamSubtopicsReportContainer key="rate" type="rate" />;
      case 17:
        return (
          <RateQuestionsReport
            rates={this.props.rates}
            ratesIsLoading={this.props.ratesIsLoading}
            loadRates={this.props.loadRates}
            generateReportForSelectedRates={
              this.props.generateRateQuestionsReport
            }
            getLastRateQuestionsReports={this.props.getLastRateQuestionsReports}
            lastRateQuestionsReports={this.props.lastRateQuestionsReports}
            /* TODO: */
            rateQuestionsReportIsLoading={false}
          />
        );
      case 18:
        return (
          <UsageStatisticsReport
            generateUsageReport={this.props.generateUsageReport}
            getUsageReports={this.props.getUsageReports}
            usageStatisticsReports={this.props.usageStatisticsReports}
            usageStatisticsReportsIsLoading={
              this.props.usageStatisticsReportsIsLoading
            }
          />
        );
      case 19:
        return (
          <AudioReport
            rates={this.props.rates}
            generateAudioReport={this.props.generateAudioReport}
            getAudioReports={this.props.getAudioReports}
            audioReportsData={this.props.audioReportsData}
            audioReportsState={this.props.audioReportsState}
          />
        );
      case 20:
        return (
          <div className="report-centered">
            <AudioAbbreviationsReport
              getLatestAudioAbbreviationsReport={
                this.props.getLatestAudioAbbreviationsReport
              }
              generateAudioAbbreviationsReport={
                this.props.generateAudioAbbreviationsReport
              }
              audioAbbreviationReport={this.props.audioAbbreviationReport}
            />
          </div>
        );
      case 21:
        return (
          <div className="report-centered">
            <BooksMissingAnswersReport
              generateBooksMissingAnswersReport={
                this.props.generateBooksMissingAnswersReport
              }
              getLatestBooksMissingAnswersReport={
                this.props.getLatestBooksMissingAnswersReport
              }
              booksMissingAnswersReportData={
                this.props.booksMissingAnswersReportData
              }
              booksMissingAnswersReportState={
                this.props.booksMissingAnswersReportState
              }
            />
          </div>
        );
      case 23:
        return (
          <div className="report-centered">
            <ReferredLeadsReport
              generateReferredLeadsReport={
                this.props.generateReferredLeadsReport
              }
              getLatestReferredLeadsReport={
                this.props.getLatestReferredLeadsReport
              }
              referredLeadsReportData={this.props.referredLeadsReportData}
              referredLeadsReportState={this.props.referredLeadsReportState}
            />
          </div>
        );
      case 24:
        return (
          <div className="report-centered">
            <AssignedToWritersReport
              generateAssignedToWritersReport={
                this.props.generateAssignedToWritersReport
              }
              getLatestAssignedToWritersReport={
                this.props.getLatestAssignedToWritersReport
              }
              assignedToWritersReportData={
                this.props.assignedToWritersReportData
              }
              assignedToWritersReportState={
                this.props.assignedToWritersReportState
              }
            />
          </div>
        );
      case 25:
        return (
          <div className="report-centered">
            <SelfPromotionReport
              generateSelfPromotionReport={
                this.props.generateSelfPromotionReport
              }
              getLatestSelfPromotionReport={
                this.props.getLatestSelfPromotionReport
              }
              selfPromotionReportData={this.props.selfPromotionReportData}
              selfPromotionReportState={this.props.selfPromotionReportState}
            />
          </div>
        );
      default:
        return (
          <div className="whiteButtons" onClick={this.handleDownloadReport}>
            Generate Report
          </div>
        );
    }
  };

  render() {
    const { selectedReport } = this.state;
    const { report = '' } = this.props;

    return (
      <Row className="reports-list-row">
        <Col xs={6} md={3} className="quals-list-container reports-list">
          <div className="rates-list-component">
            <div className="rates-title">
              <div className="flexItemsTitlePlus">Reports</div>
              <div className="line-quals-page" />
            </div>
            <div className="rates-list">
              {REPORTS.map((report) => (
                <div className="row" key={`reports-${report.id}`}>
                  <div
                    className={
                      selectedReport.id === report.id
                        ? 'rate-line active'
                        : 'rate-line'
                    }
                    onClick={() => this.setState({ selectedReport: report })}
                  >
                    <div className="description">{report.name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col md={9} style={{ overflow: 'auto', height: '100%' }}>
          {this.props.isLoading ? (
            <Spinner />
          ) : (
            <div style={{ height: '100%' }}>{this.renderReportComponent()}</div>
          )}
        </Col>
        <div style={{ display: 'none' }}>
          <CSVLink
            id="report-download"
            filename={this.state.filename}
            data={report}
          />
        </div>
      </Row>
    );
  }
}

Reports.propTypes = {
  rates: PropTypes.array.isRequired,
  ratesIsLoading: PropTypes.bool.isRequired,
  loadRates: PropTypes.func.isRequired,
  downloadReport: PropTypes.func.isRequired,
  onClearReport: PropTypes.func.isRequired,
  getBibliographyReportForGivenRates: PropTypes.func.isRequired,
  bibliographyReport: PropTypes.array,
  bibliographyReportIsLoading: PropTypes.bool,
  bibliographyReportError: PropTypes.string,
  generateFavoriteQuestionsReport: PropTypes.func.isRequired,
};
